import React from "react";

import styles from "./DeclineOverlay.scss";

const UndoOverlay = ({ onConfirm, onCancel }) => (
  <div className={`${styles.overlay} ${styles.undoOverlay}`}>
    <h3>Are you sure you want to undo declining this proposal?</h3>

    <button
      type="button"
      className={styles.confirm}
      onClick={() => onConfirm()}
    >
      Yes
    </button>
    <button type="button" className={styles.cancel} onClick={() => onCancel()}>
      Wait, nevermind!
    </button>
  </div>
);

export default UndoOverlay;



// WEBPACK FOOTER //
// ./src/routes/employer/projectInformation/components/candidates/UndoOverlay.js